module.exports = __webpack_public_path__ + "static/media/barcode.dc2baa90.svg";